import React from 'react';
import { Helmet as ReactHelmet } from "react-helmet";

import { usePageTitle } from 'hooks/usePageTitle';

interface HelmetProps {
  children?: React.ReactNode;
}

export const Helmet: React.FC<HelmetProps> = ({ children }) => {
  const pageTitle = usePageTitle()

  return (
    <ReactHelmet>
      {!pageTitle && (
        <title>RoomSync</title>
      )}
      {pageTitle && (
        <title>{pageTitle} | RoomSync</title>
      )}
      {children}
    </ReactHelmet>
  );
};
